import * as React from 'react';
import { Link } from 'src/components/atoms';
import { FormInput } from 'src/components/molecules';
import { FormInputVariant, FormState } from 'src/types';
import { LoginFlow } from '../../../types';
import LoginContainer from '../LoginContainer';

interface Props {
  email: string;
  code: string;
  loading: boolean;
  onCodeChange: Function;
  resendCode: Function;
  loginWithCode: Function;
  setFlow: Function;
}

function LoginCode(props: Props) {
  return (
    <div data-testid="password-input">
      <LoginContainer
        header="Log in"
        description="Your account is protected with two factor authentication, a code has been emailed to you."
        includeForm={true}
        buttonText="Continue"
        buttonOnClick={() => props.loginWithCode()}
        data-testid="submit-code"
        buttonDisabled={!props.code || !props.code.length}
        backButtonOnClick={() => props.setFlow(LoginFlow.USERNAME)}
        loading={props.loading}
      >
        <FormInput
          label="Code"
          variant={FormInputVariant.INPUT}
          placeholder="Code"
          data-testid="code-input"
          state={FormState.DEFAULT}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            props.onCodeChange(event.currentTarget.value);
          }}
          type="code"
          value={props.code}
          enterKeyAction={() => props.loginWithCode()}
          $removeMarginBottom={true}
        />

        <Link
          size="medium"
          onClick={() => !props.loading && props.resendCode()}
        >
          Resend code to your email
        </Link>
      </LoginContainer>
    </div>
  );
}

export default LoginCode;
